import { useDevices } from 'common'
import { ProductCardProps } from 'interfaces'
import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import { ProductCardDesktop } from './ProductCardDesktop'
import { ProductCardMobile } from './ProductCardMobile'

export const ProductCard = observer((props: ProductCardProps): ReactElement => {
  const { isMobileLarge } = useDevices()

  return isMobileLarge ? (
    <ProductCardMobile {...props} />
  ) : (
    <ProductCardDesktop {...props} />
  )
})
